export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}training-company/training-company/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/TrainingCompany/index.js